export default __webpack_public_path__ + "static/media/whatsapp.cc08fa9f.svg";